const evaluationTypes = Object.freeze({
  Todos: 1,
  Educativos: 2,
  Relacionados: 3,
});

export default evaluationTypes;
